var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colorpickerContainer"},_vm._l((_vm.colors),function(color,index){return _c('div',{key:index,class:{'active': color === _vm.activeColor,'colorpicker':true},style:({'background-color': color}),on:{"click":function($event){return _vm.changeSelectedColor(color)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20408e2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/toolbar/colorPicker.vue
// module id = null
// module chunks = 